import User from "../user/User";
import Store from "../domain/Store";
import {toBase64} from "../../mcn-helpers";
import Offer from "../offer/Offer";
import Addons from "../Addons/Addons";
import CheckoutData from "./CustomData/CheckoutData";
import Product from "../product/Product";
import Image from "../image/Image";
import OfferOptionCollection from "./OfferOptionCollection";
import UpsellOptionCollection from "./UpsellOptionCollection";
import CrossSellOptionCollection from "./CrossSellOptionCollection";
import BlockCollection from "../blocks/BlockCollection";
import OrderCollection from "../order/OrderCollection";
import JsonMappedModel from "../helpers/JsonMappedModel";
import Tracking from "../tracking/Tracking";
import CheckoutFormSettings from "./FormSettings/CheckoutFormSettings";
import CountryCollection from "../country/CountryCollection";
import Country from "../country/Country";
import Domain from "@/assets/js/models/domain/Domain";
import Currency from "@/assets/js/models/Currency";

export default class SalePage extends JsonMappedModel {

    static ACTIVE_STATUS = 'active'
    static DRAFT_STATUS = 'draft'
    static PAUSED_STATUS = 'paused'

    static LONG_CHECKOUT = 'long'
    static SHORT_CHECKOUT = 'short'
    static CUSTOM_CHECKOUT = 'custom'

    static PRODUCT_PRODUCT_TYPE = 'product'
    static OFFER_PRODUCT_TYPE = 'offer'

    static OFFER_COUNTRY_DEFAULT_CURRENCY = 'offer-country-currency';
    static INVENTORY_COUNTRY_DEFAULT_CURRENCY = 'inventory-country-currency';
    static CUSTOM_CURRENCY = 'custom-currency';
    static USD_DEFAULT_CURRENCY = 'USD';
    static EUR_DEFAULT_CURRENCY = 'EUR';

    static COD_PAYMENT_TYPE = 'cod'
    static CARD_PAYMENT_TYPE = 'card'

    static ENGLISH_LANGUAGE = 'en'
    static SPANISH_LANGUAGE = 'es'
    static ARABIC_LANGUAGE = 'ar'
    static FRENCH_LANGUAGE = 'fr'
    static ITALIAN_LANGUAGE = 'it'

    static SAME_COUNTRY_SELECT_TYPE = 'same-country'
    static WORLD_WIDE_COUNTRY_SELECT_TYPE = 'world-wide'
    static MULTIPLE_COUNTRY_SELECT_TYPE = 'multiple-countries'

    static id_attribute_name = 'sale_page_id'
    static user_id_attribute_name = 'user_id'
    static offer_id_attribute_name = 'offer_id'
    static product_id_attribute_name = 'product_id'
    static country_select_type_attribute_name = 'country_select_type'
    static shipping_countries_attribute_name = 'shipping_countries'
    static product_attribute_name = 'product'
    static inventory_country_id_attribute_name = 'inventory_country_id'
    static inventory_country_attribute_name = 'inventory_country'
    static updated_by_attribute_name = 'updated_by'
    static sale_page_user_attribute_name = 'sale_page_user'
    static checkout_length_attribute_name = 'checkout_length'
    static checkout_title_attribute_name = 'checkout_title'
    static checkout_subtitle_attribute_name = 'checkout_subtitle'
    static domain_id_attribute_name = 'domain_id'
    static sale_page_domain_attribute_name = 'sale_page_domain'
    static domain_attribute_name = 'domain'
    static sale_page_status_attribute_name = 'sale_page_status'
    static sale_page_language_attribute_name = 'sale_page_language'
    static sale_page_blocks_attribute_name = 'sale_page_blocks'
    static sale_page_name_attribute_name = 'sale_page_name'
    static sale_page_short_product_name_attribute_name = 'sale_page_short_product_name'
    static sale_page_nickname_attribute_name = 'sale_page_nickname'
    static sale_page_product_title_attribute_name = 'sale_page_product_title'
    static description_attribute_name = 'description'
    static sale_page_product_video_attribute_name = 'sale_page_product_video'
    static sale_page_image_attribute_name = 'sale_page_image'
    static sale_page_offer_options_attribute_name = 'sale_page_offer_options'
    static sale_page_upsells_attribute_name = 'sale_page_upsells'
    static sale_page_cross_sells_attribute_name = 'sale_page_cross_sells'
    static offer_attribute_name = 'offer'
    static with_trashed_offer_attribute_name = 'with_trashed_offer'
    static sale_page_offer_attribute_name = 'sale_page_offer'
    static sale_page_with_trashed_offer_attribute_name = 'sale_page_with_trashed_offer'
    static sale_page_pixels_attribute_name = 'sale_page_pixels'
    static sale_page_addons_attribute_name = 'sale_page_addons'
    static sale_page_orders_attribute_name = 'sale_page_orders'
    static visit_logs_count_attribute_name = 'visit_logs_count'
    static sale_page_orders_count_attribute_name = 'sale_page_orders_count'
    static default_sale_price_attribute_name = 'default_sale_price'
    static default_currency_attribute_name = 'default_currency'
    static currency_attribute_name = 'currency'
    static currency_symbol_attribute_name = 'currency_symbol'
    static custom_data_attribute_name = 'custom_data'
    static created_at_attribute_name = 'created_at'
    static updated_at_attribute_name = 'updated_at'
    static product_type_attribute_name = 'product_type'
    static with_trashed_product_attribute_name = 'with_trashed_product'
    static currency_id_attribute_name = 'currency_id'
    static store_attribute_name = 'store'
    static custom_currency_attribute_name = 'custom_currency'

    #attributes = {
        [SalePage.id_attribute_name]: null,
        [SalePage.user_id_attribute_name]: null,
        [SalePage.offer_id_attribute_name]: null,
        [SalePage.currency_id_attribute_name]: null,
        [SalePage.product_type_attribute_name]: null,
        [SalePage.product_id_attribute_name]: null,
        [SalePage.country_select_type_attribute_name]: null,
        [SalePage.product_attribute_name]: Product,
        [SalePage.with_trashed_product_attribute_name]: Product,
        [SalePage.shipping_countries_attribute_name]: CountryCollection,
        [SalePage.inventory_country_id_attribute_name]: null,
        [SalePage.inventory_country_attribute_name]: Country,
        [SalePage.updated_by_attribute_name]: User,
        [SalePage.sale_page_user_attribute_name]: User,
        [SalePage.checkout_length_attribute_name]: SalePage.LONG_CHECKOUT,
        [SalePage.checkout_title_attribute_name]: null,
        [SalePage.checkout_subtitle_attribute_name]: null,
        [SalePage.domain_id_attribute_name]: null,
        [SalePage.sale_page_domain_attribute_name]: Store,
        [SalePage.domain_attribute_name]: Store,
        [SalePage.store_attribute_name]: Store,
        [SalePage.sale_page_status_attribute_name]: null,
        [SalePage.sale_page_language_attribute_name]: null,
        [SalePage.sale_page_blocks_attribute_name]: BlockCollection,
        [SalePage.sale_page_name_attribute_name]: null,
        [SalePage.sale_page_short_product_name_attribute_name]: null,
        [SalePage.sale_page_nickname_attribute_name]: null,
        [SalePage.sale_page_product_title_attribute_name]: null,
        [SalePage.description_attribute_name]: null,
        [SalePage.sale_page_product_video_attribute_name]: null,
        [SalePage.sale_page_image_attribute_name]: null,
        [SalePage.sale_page_offer_options_attribute_name]: OfferOptionCollection,
        [SalePage.sale_page_upsells_attribute_name]: UpsellOptionCollection,
        [SalePage.sale_page_cross_sells_attribute_name]: CrossSellOptionCollection,
        [SalePage.sale_page_pixels_attribute_name]: Tracking,
        [SalePage.sale_page_addons_attribute_name]: Addons,
        [SalePage.sale_page_orders_attribute_name]: OrderCollection,
        [SalePage.visit_logs_count_attribute_name]: 0,
        [SalePage.sale_page_orders_count_attribute_name]: 0,
        [SalePage.default_sale_price_attribute_name]: 0,
        [SalePage.default_currency_attribute_name]: SalePage.OFFER_COUNTRY_DEFAULT_CURRENCY,
        [SalePage.currency_attribute_name]: null,
        [SalePage.currency_symbol_attribute_name]: null,
        [SalePage.custom_data_attribute_name]: CheckoutData,
        [SalePage.created_at_attribute_name]: null,
        [SalePage.updated_at_attribute_name]: null,
        [SalePage.custom_currency_attribute_name]: Currency,
    }

    constructor(data) {
        super(data);
        this.map(data, this.#attributes)
    }

    static getIdAttributeName() {
        return SalePage.id_attribute_name
    }

    static getCurrencySymbolAttributeName() {
        return SalePage.currency_symbol_attribute_name
    }

    static getInventoryCountryAttributeName() {
        return SalePage.inventory_country_attribute_name
    }

    static getSalePageWithTrashedOfferAttributeName() {
        return SalePage.sale_page_with_trashed_offer_attribute_name
    }

    static getWithTrashedOfferAttributeName() {
        return SalePage.with_trashed_offer_attribute_name
    }

    static getShippingCountriesAttributeName() {
        return SalePage.shipping_countries_attribute_name
    }

    static getNameAttributeName() {
        return SalePage.sale_page_name_attribute_name
    }

    static getSalePageOfferAttributeName() {
        return SalePage.sale_page_offer_attribute_name
    }

    static getStatusAttributeName() {
        return SalePage.sale_page_status_attribute_name
    }

    static getDomainIdAttributeName() {
        return SalePage.domain_id_attribute_name
    }

    static getOfferIdAttributeName() {
        return SalePage.offer_id_attribute_name
    }

    static getProductIdAttributeName() {
        return SalePage.product_id_attribute_name
    }

    static getProductAttributeName() {
        return SalePage.product_attribute_name
    }

    static getDefaultCurrencyAttributeName() {
        return SalePage.default_currency_attribute_name
    }

    static getLanguageAttributeName() {
        return SalePage.sale_page_language_attribute_name
    }

    static getProductTitleAttributeName() {
        return SalePage.sale_page_product_title_attribute_name
    }

    static getDescriptionAttributeName() {
        return SalePage.description_attribute_name
    }

    static getVideoAttributeName() {
        return SalePage.sale_page_product_video_attribute_name
    }

    static getAddonsAttributeName() {
        return SalePage.sale_page_addons_attribute_name
    }

    static getCountrySelectTypeAttributeName() {
        return SalePage.country_select_type_attribute_name
    }

    static getPixelsAttributeName() {
        return SalePage.sale_page_pixels_attribute_name
    }

    static getBlocksAttributeName() {
        return SalePage.sale_page_blocks_attribute_name
    }

    static getCheckoutOptionsAttributeName() {
        return SalePage.sale_page_offer_options_attribute_name
    }

    static getUpsellsAttributeName() {
        return SalePage.sale_page_upsells_attribute_name
    }

    static getCrossSellsAttributeName() {
        return SalePage.sale_page_cross_sells_attribute_name
    }

    static getCheckoutTitleAttributeName() {
        return SalePage.checkout_title_attribute_name
    }

    static getCheckoutSubTitleAttributeName() {
        return SalePage.checkout_subtitle_attribute_name
    }

    static getCheckoutLengthAttributeName() {
        return SalePage.checkout_length_attribute_name
    }

    static getShortProductNameAttributeName() {
        return SalePage.sale_page_short_product_name_attribute_name
    }

    static getCustomDataAttributeName() {
        return SalePage.custom_data_attribute_name
    }

    static getCurrencyIdAttributeName() {
        return SalePage.currency_id_attribute_name
    }

    static getStoreAttributeName() {
        return SalePage.store_attribute_name
    }

    static getCustomCurrencyAttributeName() {
        return SalePage.custom_currency_attribute_name
    }

    static getDefaultSalePriceAttributeName() {
        return SalePage.default_sale_price_attribute_name
    }

    getDefaultSalePrice(){
        return this.getAttribute(SalePage.getDefaultSalePriceAttributeName())
    }

    getCustomCurrency() {
        return this.getAttribute(SalePage.getCustomCurrencyAttributeName())
    }

    getCustomCurrencyCode() {
        const customCurrency = this.getCustomCurrency()
        return customCurrency instanceof Currency ? customCurrency.getCode() : null
    }

    getCustomCurrencySymbol() {
        const customCurrency = this.getCustomCurrency()
        return customCurrency instanceof Currency ? customCurrency.getSymbol() : null
    }

    getCreationDate() {
        return this.getAttribute(SalePage.created_at_attribute_name)
    }

    getUpdateDate() {
        return this.getAttribute(SalePage.updated_at_attribute_name)
    }

    static getDefaultCurrencies() {
        return [
            SalePage.EUR_DEFAULT_CURRENCY,
            SalePage.USD_DEFAULT_CURRENCY,
            SalePage.OFFER_COUNTRY_DEFAULT_CURRENCY
        ]
    }

    static getPageLanguages() {
        return [
            SalePage.ENGLISH_LANGUAGE,
            SalePage.FRENCH_LANGUAGE,
            SalePage.ARABIC_LANGUAGE,
            SalePage.ITALIAN_LANGUAGE,
            SalePage.SPANISH_LANGUAGE
        ]
    }

    getShippingCountries() {
        return this.getAttribute(SalePage.getShippingCountriesAttributeName()) ?? []
    }

    getCountrySelectType() {
        return this.getAttribute(SalePage.getCountrySelectTypeAttributeName())
    }

    getCurrency() {
        return this.getAttribute(SalePage.currency_attribute_name)
    }

    static isSalePage(sale_page) {
        return sale_page instanceof SalePage
    }

    getPageName() {
        return this.getAttribute(SalePage.sale_page_name_attribute_name)
    }

    getName() {
        return this.getAttribute(SalePage.sale_page_name_attribute_name)
    }

    getPageLanguage() {
        return this.getAttribute(SalePage.sale_page_language_attribute_name)
    }

    getLanguage() {
        return this.getAttribute(SalePage.sale_page_language_attribute_name)
    }

    getDomainId() {
        return this.getAttribute(SalePage.domain_id_attribute_name)
    }

    getSalePageOffer() {
        return this.getAttribute(SalePage.sale_page_offer_attribute_name)
    }

    getDomain() {
        return this.getAttribute(SalePage.sale_page_domain_attribute_name)
            ?? this.getAttribute(SalePage.domain_attribute_name)
            ?? this.getAttribute(SalePage.store_attribute_name)
    }

    hasDomainDnsActive() {
        let domain = this.getDomain()
        return domain instanceof Store ? domain.hasDnsActive() : false
    }

    hasDomainSslActive() {
        let domain = this.getDomain()
        return domain instanceof Store ? domain.hasSslActive() : false
    }

    getNickName() {
        return this.getAttribute(SalePage.sale_page_nickname_attribute_name)
    }

    getProductTitle() {
        return this.getAttribute(SalePage.sale_page_product_title_attribute_name)
    }

    getId() {
        return this.getAttribute(SalePage.id_attribute_name)
    }

    getSalePageLink(data = {_domain: null, nick_name: null, page_id: null}) {
        let {_domain, nick_name, page_id} = data
        let hostname = window.location.hostname
        let isLocalhost = hostname === 'localhost'
        let protocol = `http${isLocalhost ? '' : 's'}://`
        let store = this.getDomain()
        let domain = store instanceof Store ? store.getDomain() : null
        let substitutionDomain = (store instanceof Store ? store.getSubstitutionDomain() : null) ?? _domain
        let domainName = domain instanceof Domain ? domain.getName() : substitutionDomain instanceof Domain ? substitutionDomain.getName() : null
        let nickName = this.getProductTitle()
        let urlDomain = domainName ? [protocol, domainName].join('') : process.env.VUE_APP_API_BASE_URL
        let salePageId = this.getId() ?? page_id
        let encodedId = toBase64(salePageId)
        let url = [urlDomain, '/', nickName, '/', encodedId].join('')
        return encodeURI(url)
    }

    getLink(...args) {
        return this.getSalePageLink(args)
    }

    getOfferCountry() {
        let offer = this.getSalePageOffer()
        return offer instanceof Offer ? offer.getOfferCountry() : null
    }

    getOriginalProduct(trashed = false) {
        return this.getAttribute(SalePage.getProductAttributeName())
    }

    static getWithTrashedProductAttributeName() {
        return SalePage.with_trashed_product_attribute_name
    }

    getProduct(trashed) {
        if (this.isProductProductType()) {

            if (trashed) {
                return this.getAttribute(SalePage.getWithTrashedProductAttributeName())
            }

            return this.getAttribute(SalePage.getProductAttributeName())
        }

        let offer = this.getOffer()
        return offer instanceof Offer ? offer.getProduct(trashed) : null
    }

    getImage() {
        let product = this.getProduct()
        return product instanceof Product ? product.getImage() : null
    }

    getCurrencySymbol() {
        return this.getAttribute(SalePage.currency_symbol_attribute_name)
    }

    getOriginalProductImage(trashed = false) {
        let product = this.getOriginalProduct(trashed)
        return product instanceof Product ? product.getImage() : null
    }

    getSalePageOfferImage() {
        let offer = this.getSalePageOffer()
        return offer instanceof Offer ? offer.getOfferProductImage() : null
    }

    getSalePageOfferImageUrl() {
        let image = this.getSalePageOfferImage()
        return image instanceof Image ? image.getUrl() : null
    }

    getSalePageWithTrashedOffer() {
        return this.getAttribute(SalePage.sale_page_with_trashed_offer_attribute_name) ?? this.getAttribute(SalePage.sale_page_offer_attribute_name)
    }

    getVisitCount() {
        return this.getAttribute(SalePage.visit_logs_count_attribute_name)
    }

    getOriginalInventoryCountry() {
        return this.getAttribute(SalePage.getInventoryCountryAttributeName())
    }

    getSalePageSelectObject(with_object = false, text = 'text', value = 'value') {
        let item = {
            [text]: this.getName(),
            [value]: this.getId()
        }
        if (with_object) item.sale_page = this
        return item
    }

    getSeller() {
        return this.getAttribute(SalePage.sale_page_user_attribute_name)
    }

    getOrderCount() {
        return this.getAttribute(SalePage.sale_page_orders_count_attribute_name)
    }

    getOffer(trashed = false) {
        if (trashed) {
            return this.getAttribute(SalePage.sale_page_with_trashed_offer_attribute_name) ??
                this.getAttribute(SalePage.with_trashed_offer_attribute_name) ??
                this.getAttribute(SalePage.sale_page_offer_attribute_name) ??
                this.getAttribute(SalePage.offer_attribute_name)
        }

        return this.getAttribute(SalePage.sale_page_offer_attribute_name) ??
            this.getAttribute(SalePage.offer_attribute_name)
    }

    getOfferOptions() {
        return this.getAttribute(SalePage.sale_page_offer_options_attribute_name) ?? []
    }

    getFirstOfferOption() {
        return this.getOfferOptions()?.[0]
    }

    getAddons() {
        return this.getAttribute(SalePage.sale_page_addons_attribute_name)
    }

    getBlocks() {
        return this.getAttribute(SalePage.sale_page_blocks_attribute_name) ?? []
    }

    getCustomData() {
        return this.getAttribute(SalePage.custom_data_attribute_name)
    }

    getUpdatedBy() {
        return this.getAttribute(SalePage.updated_by_attribute_name)
    }

    getUser() {
        return this.getAttribute(SalePage.sale_page_user_attribute_name)
    }

    getCustomShippingData() {
        let customData = this.getCustomData()
        return customData instanceof CheckoutData ? customData.getShippingData() : null
    }

    getCustomReviewsData() {
        let customData = this.getCustomData()
        return customData instanceof CheckoutData ? customData.getReviewsData() : null
    }

    getCustomCheckoutFormSettingsData() {
        let customData = this.getCustomData()
        return customData instanceof CheckoutData ? customData.getCheckoutFormSettingsData() : null
    }

    isCardPaymentPage() {
        let paymentType = this.getPaymentType()
        if (paymentType) return paymentType === Offer.CARD_PAYMENT_TYPE

        let customCheckoutFormSettings = this.getCustomCheckoutFormSettingsData()
        let paymentMethod = customCheckoutFormSettings instanceof CheckoutFormSettings ? customCheckoutFormSettings.getPaymentMethod() : null
        return paymentMethod === CheckoutFormSettings.CARD_PAYMENT_METHOD
    }

    getPaymentType() {
        let offer = this.getOffer()
        return offer instanceof Offer ? offer.getPaymentType() : null
    }

    getShortProductName() {
        return this.getAttribute(SalePage.sale_page_short_product_name_attribute_name)
    }

    getCheckoutTitle() {
        return this.getAttribute(SalePage.checkout_title_attribute_name)
    }

    getCheckoutSubtitle() {
        return this.getAttribute(SalePage.checkout_subtitle_attribute_name)
    }

    getProductType() {
        return this.getAttribute(SalePage.product_type_attribute_name)
    }

    isProductProductType() {
        return this.getProductType() === SalePage.PRODUCT_PRODUCT_TYPE
    }
}